// global
import React, { Component, memo } from 'react';
import PropTypes from 'prop-types';
// api
import * as Branchs from 'app/api/branch';
// views
import NestedDropdown from 'app/components/commons/dropdown/nested/NestedDropdown';
import CustomDropdown from 'app/components/commons/dropdown/CustomDropdown';
import ErrorLabel from 'app/components/commons/label/ErrorLabel';
import { sortString } from 'app/utils';

class BranchsDropdown extends Component {
  state = {
    loading: true,
    options: []
  };

  componentDidMount() {
    Branchs.getBranches().then(this.onLoadClientSuccess).catch(this.onLoadClientFail);
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onLoadClientSuccess = branchs => {
    branchs = branchs.filter(branch => branch.status === 1);
    branchs = branchs.map(branch => ({
      text: branch.name,
      value: parseInt(branch.id)
    }));
    branchs.sort((a, b) => sortString(a.text, b.text));

    const options = [{ text: '-', value: null }, ...branchs];

    if (this._isMounted) {
      this.setState({
        loading: false,
        options
      });
    }
  };

  onLoadClientFail = () => {
    if (this._isMounted) {
      this.setState({
        loading: false,
        options: []
      });
    }
  };

  render() {
    const { options, loading } = this.state;
    const {
      nested,
      value,
      onChange,
      error,
      isForm,
      width,
      required,
      disabled,
      showLabel,
      label,
      placeholder,
      styleName
    } = this.props;

    if (nested) {
      return (
        <NestedDropdown
          options={options}
          name={label}
          onOptionSelection={this.props.onOptionSelection}
        />
      );
    }

    return (
      <CustomDropdown
        loading={loading}
        options={options}
        value={value}
        onChange={onChange}
        error={error ? true : false}
        isForm={isForm}
        width={width}
        required={required}
        placeholder={placeholder}
        disabled={disabled}
        styleName={styleName}
        label={showLabel && <ErrorLabel label={label} error={error} />}
        selection
      />
    );
  }
}

BranchsDropdown.propTypes = {
  nested: PropTypes.bool,
  onOptionSelection: PropTypes.func,
  value: PropTypes.any,
  onChange: PropTypes.func,
  error: PropTypes.string,
  isForm: PropTypes.bool,
  width: PropTypes.number,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  showLabel: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  styleName: PropTypes.oneOf(['styleModal', 'styleReport', 'styleReportFilters'])
};

BranchsDropdown.defaultProps = {
  isForm: true,
  showLabel: true,
  label: 'Filial',
  placeholder: 'Filial',
  styleName: 'styleModal'
};

export default memo(BranchsDropdown);
